export type DocType = "message" | "conversation" | "person";

export interface SearchHit {
  doc_type: DocType;
  doc_id: string;
  conversation_id?: string | null;
  sender_id?: string | null;
  sender_name?: string | null;
  conversation_title?: string | null;
  snippet: string;
  hit_offsets?: Array<[number, number]>;
  avatar_url?: string | null;
  subtitle?: string | null;
  created_at?: string | null;
  entity_types?: string[];
}

export interface SearchResultPage {
  hits: SearchHit[];
  next_cursor?: string | null;
  total_estimate?: number | null;
}

export interface GroupedSearchResult {
  person: SearchResultPage;
  conversation: SearchResultPage;
  message: SearchResultPage;
}

export interface SearchRequest {
  account_id: string;
  conversation_id?: string | null;
  text: string;
  cursor?: string | null;
  limit?: number;
}

// ---------------------------------------------------------------------------
// Search v2 — per-tab types matching the new backend endpoints
// ---------------------------------------------------------------------------

export const TabId = {
  chats:    "chats",
  channels: "channels",
  people:   "people",
  messages: "messages",
  links:    "links",
} as const;
export type TabId = (typeof TabId)[keyof typeof TabId];

export type AccountScope =
  | { kind: "account"; id: string }
  | { kind: "all" };

export interface ChatHit {
  conversation_id: string;
  account_id: string;
  title: string;
  type: "direct" | "group" | "channel";
  avatar_url?: string | null;
  last_message_at?: string | null;
  last_message_preview?: string | null;
  member_count?: number;
  unread_count?: number;
}

export type ChannelHit = ChatHit;

export interface PersonHit {
  user_id: string;
  account_id: string;
  first_name?: string | null;
  last_name?: string | null;
  avatar_url?: string | null;
  email?: string | null;
  role: string;
  is_bot?: boolean;
}

export interface MessageHit {
  message_id: string;
  conversation_id: string;
  account_id: string;
  sender_id: string;
  sender_name?: string | null;
  sender_avatar_url?: string | null;
  conversation_title?: string | null;
  snippet: string;
  hit_offsets?: Array<[number, number]>;
  created_at: string;
}

export interface LinkHit extends MessageHit {
  link_urls: string[];
}

export interface SearchPage<T> {
  hits: T[];
  next_cursor?: string | null;
}
